import type { IconBaseProps, IconType } from 'react-icons';
import { LuKeyboardMusic, LuPaintbrush } from 'react-icons/lu';
import { MdOutlineSportsSoccer } from 'react-icons/md';
import { PiBackpack } from 'react-icons/pi';
import { RiSpeakLine } from 'react-icons/ri';

const iconMap: Record<string, IconType> = {
  'arts-and-crafts': LuPaintbrush,
  'language-learning': RiSpeakLine,
  music: LuKeyboardMusic,
  sports: MdOutlineSportsSoccer,
  tutoring: PiBackpack
};

export function CategoryIcon({
  categorySlug,
  ...rest
}: { categorySlug: string } & Pick<IconBaseProps, 'className'>) {
  const Icon = iconMap[categorySlug];
  if (Icon) {
    return <Icon {...rest} />;
  }
}
